import { render, staticRenderFns } from "./courseColumn.vue?vue&type=template&id=0e5b2576&scoped=true&"
import script from "./courseColumn.vue?vue&type=script&lang=js&"
export * from "./courseColumn.vue?vue&type=script&lang=js&"
import style0 from "./courseColumn.vue?vue&type=style&index=0&id=0e5b2576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5b2576",
  null
  
)

export default component.exports